import Company from "marketplace/companies/company";
import ProfileTypePage from "marketplace/_views/profiles/profile-type-page";
import { ProfileTableData } from "marketplace/_views/profiles/profile-table-data";
import { PageTab } from "marketplace/_views/profiles/profiles-page-tabs";
import { useCompanyProfileStore } from "marketplace/_views/profiles/use-marketplace-profile-store";
import { getSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useCallback } from "react";
import { useSelector } from "react-redux";

export default function CompanyProfilesPage() {
  const sessionPermissions = useSelector(getSessionPermissions);
  const profileStore = useCompanyProfileStore();
  const companyProfiles = profileStore.companyProfiles;
  const readonly = !sessionPermissions?.includesAccessToAdministration;

  const getShouldDisableRowEditing = useCallback((_profile: ProfileTableData) => readonly, [readonly]);

  return (
    <ProfileTypePage
      activeTab={PageTab.Company}
      addProfileDisabled={
        readonly ||
        !sessionPermissions?.includesReadAccessToMarketplace ||
        (companyProfiles !== undefined && companyProfiles.length > 0)
      }
      addProfileDisabledMessage={getAddProfileDisabledMessage(readonly, companyProfiles)}
      getShouldDisableRowEditing={getShouldDisableRowEditing}
      profileStore={profileStore}
    />
  );
}

function getAddProfileDisabledMessage(readonly: boolean, companyProfiles?: Company[]): string {
  if (readonly) return "You don't have permission";
  if (companyProfiles !== undefined && companyProfiles.length > 0) {
    return "You can only have one company profile";
  }
  return "";
}
